import { createStore } from 'vuex'
import rwaModule from './modules/rwa'
import languageModule from './modules/language'

export default createStore({
  modules: {
    rwa: rwaModule,
    language: languageModule,
  }
}) 